/* PARFUMPROBEN VERSAND – Warenkorb-Vorteile mit Gratisprobe (gehört zu snippets/ppv-cart-rewards.liquid).
   „Perlenkette“ (13e), darunter die gewählte Gratisprobe mit „Wechseln“ (19b – klappt drei Karten auf, ebenso ein Tipp
   auf den Flakon in der Kette) und „Zuletzt angesehen“ (6a) im Einschub. */
(() => {
  const ELEMENT_NAME = 'ppv-cart-rewards';
  const STORE_KEY = 'ppv.gratisprobe';
  const ATTRIBUTE = 'Gratisprobe';
  const ATTRIBUTE_VARIANT = 'Gratisprobe-Variante';
  const RECENT_KEY = 'ppv.zuletzt';
  const RECENT_CACHE_KEY = 'ppv.zuletzt.produkte.v2';
  const RECENT_GAP = 1500; /* „Zuletzt angesehen“ nur, wenn bis zur nächsten Schwelle höchstens 15 € fehlen */
  const RECENT_MAX = 6;
  const RECENT_ERROR = 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
  /* Beide öffnen und schließen dieselbe Auswahl: „Wechseln“ in der Zeile und der Flakon in der Kette */
  const TOGGLES = 'button.ppv-pe__ms--sample, .ppv-fs-row__btn';
  const root = () => window.Shopify?.routes?.root || '/';

  document.querySelectorAll('style[data-ppv-cart-rewards-style]').forEach((style, index) => {
    if (index === 0) {
      if (style.parentElement !== document.head) document.head.appendChild(style);
    } else {
      style.remove();
    }
  });

  /* Gemeinsamer Zustand für Einschub und Warenkorbseite: letzter Warenkorb, Wahl, Abgleich des Vermerks. */
  const state =
    window.__PPV_FREE_SAMPLE__ ||
    (window.__PPV_FREE_SAMPLE__ = { cart: null, queue: Promise.resolve(), pending: 0, postKey: null, postSeq: 0, fullAt: 0 });

  /* Die Wahl gilt nur für diesen Warenkorb – nach einer Bestellung (neuer Warenkorb) ist sie vergessen. */
  const readChoice = () => {
    let value = null;
    try {
      value = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
    } catch (error) {
      value = state.memoryChoice || null;
    }
    if (!value || !value.variant) return null;
    const token = state.cart && state.cart.token;
    return value.cart && token && value.cart !== token ? null : value;
  };

  const writeChoice = choice => {
    const value = choice ? { ...choice, cart: (state.cart && state.cart.token) || null } : null;
    state.memoryChoice = value;
    try {
      if (value) localStorage.setItem(STORE_KEY, JSON.stringify(value));
      else localStorage.removeItem(STORE_KEY);
    } catch (error) {
      /* Ohne Speicher gilt die Wahl bis zum Neuladen. */
    }
  };

  /* Angebotene Proben und Schwelle aus dem Block lesen. Während das Theme den Einschub neu zeichnet, steckt der Block
     kurz nicht im Dokument – dann gilt der zuletzt gelesene Stand (sonst würde der Vermerk fälschlich gelöscht). */
  const offered = () => {
    if (document.querySelector(ELEMENT_NAME)) {
      const cards = document.querySelectorAll(`${ELEMENT_NAME} .ppv-free-sample__card`);
      state.offered = new Map([...cards].map(card => [card.dataset.variant, card.dataset.title]));
    }
    return state.offered || new Map();
  };

  const thresholdOf = () => {
    const value = Number(document.querySelector(ELEMENT_NAME)?.dataset.sampleThreshold);
    if (value) state.threshold = value;
    return state.threshold || 3000;
  };

  /* Wahl dieses Warenkorbs: vorgemerkt, sonst der Vermerk, den der Warenkorb schon trägt (anderer Tab, Gerät …).
     Ohne eigene Wahl ist ab dem Mindestbestellwert automatisch die erste angebotene Probe gewählt – so nennt jede
     Bestellung ab 30 € eine Probe; der Kunde kann jederzeit eine andere antippen. */
  const currentChoice = cart => {
    const options = offered();
    const stored = readChoice();
    if (stored && options.has(String(stored.variant))) return { variant: String(stored.variant), title: options.get(String(stored.variant)) };
    const attributes = (cart && cart.attributes) || {};
    const variant = String(attributes[ATTRIBUTE_VARIANT] || '');
    if (!stored && variant && options.has(variant)) {
      const adopted = { variant, title: options.get(variant) };
      writeChoice(adopted);
      return adopted;
    }
    if (cart && cart.item_count > 0 && cart.total_price >= thresholdOf() && options.size) {
      const [firstVariant, firstTitle] = options.entries().next().value;
      const preset = { variant: firstVariant, title: firstTitle };
      writeChoice(preset);
      return preset;
    }
    return null;
  };

  const attributeKey = (title, variant) => `${title}\n${variant}`;

  /* Vermerk am Warenkorb nur ab dem Mindestbestellwert – darunter bleibt die Wahl nur vorgemerkt.
     Verglichen wird mit dem neuesten Stand: läuft gerade eine Speicherung, zählt deren Wert. So geht pro echter
     Änderung genau eine Anfrage raus, auch wenn mehrere ältere Warenkorb-Stände nacheinander eintreffen. */
  const syncAttributes = cart => {
    if (!cart) return state.queue;
    const choice = currentChoice(cart);
    const wanted = choice && cart.item_count > 0 && cart.total_price >= thresholdOf() ? choice : null;
    const title = wanted ? wanted.title : '';
    const variant = wanted ? String(wanted.variant) : '';
    const want = attributeKey(title, variant);
    const attributes = cart.attributes || {};
    const have =
      state.postKey !== null && state.postKey !== undefined
        ? state.postKey
        : attributeKey(attributes[ATTRIBUTE] || '', String(attributes[ATTRIBUTE_VARIANT] || ''));
    if (have === want) return state.queue;
    state.postKey = want;
    state.pending += 1;
    state.queue = state.queue
      .then(() =>
        fetch(`${root()}cart/update.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { [ATTRIBUTE]: title, [ATTRIBUTE_VARIANT]: variant } })
        })
      )
      .then(response => (response.ok ? response.json() : null))
      .then(updated => {
        if (state.postKey === want) state.postKey = null;
        if (updated) {
          state.postSeq += 1;
          applyCart(updated);
        }
      })
      .catch(() => {
        if (state.postKey === want) state.postKey = null;
      })
      .finally(() => {
        state.pending -= 1;
      });
    return state.queue;
  };

  const renderAll = () => document.querySelectorAll(ELEMENT_NAME).forEach(element => element.render?.());

  /* Neuer Warenkorb-Stand: zeichnen, Vermerk abgleichen und Bescheid geben (Pille am Symbol und Erinnerung unten,
     assets/ppv-cart-hints.js). */
  let readTimer;
  let readForced = false;
  const applyCart = (cart, fromEvent) => {
    if (!cart) return;
    state.cart = cart;
    state.fullAt = Date.now();
    if (fromEvent && !readForced) clearTimeout(readTimer);
    document.querySelectorAll(ELEMENT_NAME).forEach(element => {
      element.currency = cart.currency || element.currency;
      element.dataset.total = String(cart.total_price || 0);
      element.dataset.count = String(cart.item_count || 0);
    });
    renderAll();
    syncAttributes(cart);
    document.dispatchEvent(new CustomEvent('ppv:cart', { detail: cart }));
  };

  /* Warenkorb lesen: nie zwei Anfragen gleichzeitig. Was währenddessen angestoßen wird, liest danach genau einmal. */
  let reading = null;
  let readAgain = false;
  const readCart = () => {
    clearTimeout(readTimer);
    readForced = false;
    if (reading) {
      readAgain = true;
      return reading;
    }
    const postsBefore = state.postSeq;
    reading = fetch(`${root()}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(response => (response.ok ? response.json() : null))
      .then(cart => {
        if (!cart) return;
        /* Wurde währenddessen ein Vermerk gespeichert, ist dessen Antwort neuer als diese. */
        if (state.postSeq !== postsBefore && state.cart) cart.attributes = state.cart.attributes;
        applyCart(cart);
      })
      .catch(() => {})
      .finally(() => {
        reading = null;
        if (readAgain) {
          readAgain = false;
          requestRead(true);
        }
      });
    return reading;
  };

  /* Anstoß gebündelt. force: der Warenkorb hat sich sicher geändert (z. B. etwas hinzugefügt). Ohne force – das
     Theme hat nur neu gezeichnet – genügt ein vollständiger Stand, der eben erst kam. */
  const requestRead = force => {
    if (!force && !readForced && (reading || Date.now() - (state.fullAt || 0) < 400)) return;
    if (force) readForced = true;
    clearTimeout(readTimer);
    readTimer = setTimeout(readCart, 150);
  };

  /* Zuletzt angesehen: Handles schreibt assets/ppv-cart-hints.js auf jeder Produktseite mit (neueste zuerst). */
  const recentHandles = () => {
    try {
      const list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      const since = Date.now() - 30 * 24 * 3600 * 1000;
      return Array.isArray(list) ? list.filter(entry => entry && entry.h && (entry.t || 0) > since).map(entry => String(entry.h)) : [];
    } catch (error) {
      return [];
    }
  };

  /* Produktdaten der zuletzt angesehenen Düfte: einmal laden, 10 Minuten im Tab merken. */
  const recentCache = (() => {
    let memory = null;
    const read = () => {
      if (memory) return memory;
      try {
        memory = JSON.parse(sessionStorage.getItem(RECENT_CACHE_KEY) || '{}') || {};
      } catch (error) {
        memory = {};
      }
      return memory;
    };
    const write = () => {
      try {
        sessionStorage.setItem(RECENT_CACHE_KEY, JSON.stringify(memory));
      } catch (error) {
        /* Ohne Speicher bleibt es beim Merken im Speicher der Seite. */
      }
    };
    return { read, write };
  })();

  const imageUrl = (src, width) => {
    if (!src) return '';
    let url = String(src);
    if (url.startsWith('//')) url = `https:${url}`;
    return `${url}${url.includes('?') ? '&' : '?'}width=${width}`;
  };

  /* Bundles gehören nicht in die Reihe – gleiche Regel wie beim Größen-Wähler: „bundle“ im Titel oder mindestens
     zwei Duftkarten (class="perf-card) in der Beschreibung. */
  const isBundle = product =>
    /bundle/i.test(product.title || '') || (String(product.description || '').match(/class="perf-card/g) || []).length >= 2;

  /* Läuft für einen Handle schon eine Anfrage, warten alle auf dieselbe. */
  const recentLoading = new Map();
  const loadRecentProduct = handle => {
    const hit = recentCache.read()[handle];
    if (hit && Date.now() - hit.t < 10 * 60 * 1000) return Promise.resolve(hit.d);
    if (recentLoading.has(handle)) return recentLoading.get(handle);
    /* Nur „gibt es nicht mehr“ (404) wird gemerkt – bei 429 oder Netzfehlern versucht es das nächste Öffnen erneut. */
    const loading = fetch(`${root()}products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(response => {
        if (response.status === 404) return null;
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
      })
      .then(product => {
        let data = null;
        if (product && product.available && !isBundle(product) && !(product.tags || []).includes('gift-hidden')) {
          const variant = (product.variants || []).find(item => String(item.title || '').toLowerCase().replace(/\s/g, '') === '2ml');
          if (variant && variant.available) {
            data = {
              handle: product.handle,
              title: String(product.title || '').replace(/ Probe$/, ''),
              vendor: product.vendor || '',
              img: imageUrl((variant.featured_image && variant.featured_image.src) || product.featured_image, 120),
              variant: variant.id,
              price: variant.price
            };
          }
        }
        recentCache.read()[handle] = { t: Date.now(), d: data };
        recentCache.write();
        return data;
      })
      .catch(() => null)
      .finally(() => recentLoading.delete(handle));
    recentLoading.set(handle, loading);
    return loading;
  };

  const escapeHtml = value =>
    String(value).replace(/[&<>"']/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch]);

  const ICON_PLUS = '<svg class="ppv-rv__add" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M6 1.5v9M1.5 6h9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
  const ICON_CHECK = '<svg class="ppv-rv__check" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2.2 6.3 4.9 9l5-5.6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  let uid = 0;

  /* Nur ändern, was sich ändert – sonst liest der Bildschirmleser die Zeile bei jedem Abgleich neu vor. */
  const setText = (element, text) => {
    if (element && element.textContent !== text) element.textContent = text;
  };

  if (!customElements.get(ELEMENT_NAME)) {
    class PPVCartRewards extends HTMLElement {
      connectedCallback() {
        this.sampleThreshold = Number(this.dataset.sampleThreshold) || 3000;
        this.shippingThreshold = Number(this.dataset.shippingThreshold) || 5000;
        this.currency = this.currency || this.dataset.currency || 'EUR';
        if (!this.bound) {
          this.bound = true;
          const fold = this.querySelector('.ppv-pe__fold');
          const toggles = this.querySelectorAll(TOGGLES);
          if (fold && toggles.length) {
            uid += 1;
            fold.id = `PpvRewardsFold-${uid}`;
            toggles.forEach(toggle => toggle.setAttribute('aria-controls', fold.id));
            fold.firstElementChild?.setAttribute('inert', '');
          }
          this.addEventListener('click', event => {
            const toggle = event.target.closest(TOGGLES);
            if (toggle && this.contains(toggle)) {
              this.opener = toggle;
              this.setOpen(toggle.getAttribute('aria-expanded') !== 'true');
              return;
            }
            const card = event.target.closest('.ppv-free-sample__card');
            if (card && this.contains(card)) {
              /* Wie Optionsfelder: Antippen wählt, erneutes Antippen behält die Wahl (ab 30 € ist immer eine gewählt).
                 Danach klappt die Auswahl wieder zu – der Flakon am Meilenstein zeigt die Wahl. */
              writeChoice({ variant: card.dataset.variant, title: card.dataset.title });
              renderAll();
              syncAttributes(state.cart);
              this.setOpen(false, true);
              return;
            }
            const recent = event.target.closest('.ppv-rv__card');
            if (recent && this.contains(recent)) this.addRecent(recent);
          });
        }
        this.render();
        /* Beim Neueinsetzen nach dem Neuzeichnen nicht jedes Mal lesen – einmal pro Seite genügt. */
        if (!state.cart && !state.firstRead) {
          state.firstRead = true;
          readCart();
        }
      }

      money(cents) {
        return new Intl.NumberFormat('de-DE', { style: 'currency', currency: this.currency, minimumFractionDigits: 2 }).format(Math.max(0, cents) / 100);
      }

      /* „30 €“ statt „30,00 €“ bei glatten Beträgen */
      short(cents) {
        return cents % 100 ? this.money(cents) : `${cents / 100} €`;
      }

      setOpen(open, focusToggle) {
        const fold = this.querySelector('.ppv-pe__fold');
        const toggles = [...this.querySelectorAll(TOGGLES)];
        if (!fold || !toggles.length) return;
        /* Vor dem Sperren merken, ob der Fokus in der Auswahl steckt – inert nimmt ihn sonst mit. */
        const hadFocus = fold.contains(document.activeElement);
        fold.classList.toggle('is-open', open);
        toggles.forEach(toggle => toggle.setAttribute('aria-expanded', String(open)));
        if (open) fold.firstElementChild?.removeAttribute('inert');
        else fold.firstElementChild?.setAttribute('inert', '');
        /* Nach der Wahl zurück zu dem Knopf, der die Auswahl geöffnet hat – sonst zu „Wechseln“ */
        if (!open && focusToggle && hadFocus) {
          const back = this.opener && this.contains(this.opener) ? this.opener : this.querySelector('.ppv-fs-row__btn') || toggles[0];
          back.focus({ preventScroll: true });
        }
      }

      render() {
        const cart = state.cart;
        const total = cart ? cart.total_price || 0 : Number(this.dataset.total) || 0;
        const count = cart ? cart.item_count || 0 : Number(this.dataset.count) || 0;
        const sampleReached = total >= this.sampleThreshold;
        const shippingReached = total >= this.shippingThreshold;
        const big = this.querySelector('.ppv-pe__big');
        const sub = this.querySelector('.ppv-pe__sub');
        const chain = this.querySelector('.ppv-pe__chain');
        this.hidden = count === 0;
        /* Leerer Warenkorb: die Auswahl zuklappen, damit sie beim nächsten Füllen nicht offen dasteht */
        if (this.hidden && this.querySelector('.ppv-pe__fold.is-open')) this.setOpen(false);
        if (!big || !sub || !chain) return;

        big.classList.toggle('is-navy', shippingReached);
        if (!sampleReached) {
          setText(big, this.money(this.sampleThreshold - total));
          setText(sub, 'bis zu deiner Gratisprobe');
        } else if (!shippingReached) {
          setText(big, this.money(this.shippingThreshold - total));
          setText(sub, 'bis zum Gratisversand');
        } else {
          setText(big, 'Alles dabei');
          setText(sub, 'Gratisprobe und Gratisversand');
        }

        chain.querySelectorAll('.ppv-pe__dot').forEach(dot => dot.classList.toggle('is-on', total >= Number(dot.dataset.at)));
        const sampleStone = chain.querySelector('.ppv-pe__ms--sample');
        sampleStone?.classList.toggle('is-on', sampleReached);
        sampleStone?.classList.toggle('is-later', !sampleReached);
        chain.querySelector('.ppv-pe__ms--ship')?.classList.toggle('is-on', shippingReached);

        /* Gezeigt wird die Wahl – ohne Wahl die erste Probe, die ab 30 € automatisch dazukommt. */
        const cards = [...this.querySelectorAll('.ppv-free-sample__card')];
        if (cards.length) {
          const choice = currentChoice(cart);
          /* Vor dem ersten Lesen gilt, was der Server schon gezeigt hat (Vermerk am Warenkorb) */
          const serverShown = cart ? null : cards.find(card => card.getAttribute('aria-pressed') === 'true');
          const shown = (choice && cards.find(card => card.dataset.variant === choice.variant)) || serverShown || cards[0];
          cards.forEach(card => card.setAttribute('aria-pressed', String(card === shown)));
          const img = sampleStone?.querySelector('img');
          if (img) {
            if (shown.dataset.img) {
              if (img.getAttribute('src') !== shown.dataset.img) img.src = shown.dataset.img;
              img.hidden = false;
            } else {
              img.hidden = true;
            }
          }
          sampleStone?.setAttribute('aria-label', `Gratisprobe: ${shown.dataset.vendor} ${shown.dataset.name} – wechseln`);
          /* Zeile unter der Kette: die gewählte Probe, ab 30 € „Deine Gratisprobe“ */
          const row = this.querySelector('.ppv-fs-row');
          if (row) {
            row.classList.toggle('is-later', !sampleReached);
            const rowImg = row.querySelector('.ppv-fs-row__img img');
            if (rowImg) {
              if (shown.dataset.img) {
                if (rowImg.getAttribute('src') !== shown.dataset.img) rowImg.src = shown.dataset.img;
                rowImg.hidden = false;
              } else {
                rowImg.hidden = true;
              }
            }
            setText(row.querySelector('.ppv-fs-row__k'), sampleReached ? 'Deine Gratisprobe' : `Gratisprobe ab ${this.short(this.sampleThreshold)}`);
            setText(row.querySelector('.ppv-fs-row__n'), shown.dataset.name || '');
          }
        }

        this.renderRecent(cart, total, count);
      }

      /* 6a: zuletzt angesehene Düfte, die bis zur nächsten Schwelle helfen – erst die, die sie schaffen (günstigste
         zuerst), dann die übrigen (teuerste zuerst). Nur im Einschub, und geladen wird erst, wenn er offen ist. */
      renderRecent(cart, total, count) {
        const block = this.querySelector('.ppv-rv');
        if (!block) return;
        const drawer = this.closest('cart-drawer');
        const gap = total < this.sampleThreshold ? this.sampleThreshold - total : total < this.shippingThreshold ? this.shippingThreshold - total : 0;
        const ticket = (this.recentTicket = (this.recentTicket || 0) + 1);
        const hide = () => {
          if (block.hidden) return;
          block.classList.add('is-gone');
          clearTimeout(this.recentHideTimer);
          this.recentHideTimer = setTimeout(() => {
            if (block.classList.contains('is-gone')) block.hidden = true;
          }, 340);
        };
        if (!drawer || !cart || !count || !gap || gap > RECENT_GAP) {
          hide();
          return;
        }
        if (!drawer.classList.contains('active')) return;
        /* Nach einem Tipp auf „+“ bleibt der Haken kurz stehen, bevor die Reihe neu gezeichnet wird. */
        const wait = (this.recentHoldUntil || 0) - Date.now();
        if (wait > 0) {
          clearTimeout(this.recentHoldTimer);
          this.recentHoldTimer = setTimeout(() => this.render(), wait);
          return;
        }
        const inCart = new Set((cart.items || []).map(item => item.handle));
        const handles = recentHandles().filter(handle => !inCart.has(handle)).slice(0, 10);
        if (!handles.length) {
          hide();
          return;
        }
        Promise.all(handles.map(loadRecentProduct)).then(products => {
          if (ticket !== this.recentTicket) return;
          const offers = products
            .filter(Boolean)
            .filter(product => !inCart.has(product.handle))
            .map(product => ({ ...product, crosses: product.price >= gap }))
            .sort((a, b) => {
              if (a.crosses !== b.crosses) return a.crosses ? -1 : 1;
              return a.crosses ? a.price - b.price : b.price - a.price;
            })
            .slice(0, RECENT_MAX);
          if (!offers.length) {
            hide();
            return;
          }
          const scroller = block.querySelector('.ppv-rv__scroll');
          const key = offers.map(offer => `${offer.variant}:${offer.price}:${offer.crosses ? 1 : 0}`).join('|');
          if (scroller && scroller.dataset.key !== key) {
            scroller.dataset.key = key;
            scroller.innerHTML = offers
              .map(
                offer =>
                  `<button type="button" class="ppv-rv__card${offer.crosses ? ' is-cross' : ''}" data-variant="${offer.variant}" data-name="${escapeHtml(offer.title)}" aria-label="${escapeHtml(`${offer.title}, 2 ml, ${this.money(offer.price)} hinzufügen`)}">` +
                  `<span class="ppv-rv__img">${offer.img ? `<img src="${escapeHtml(offer.img)}" alt="" width="40" height="50" loading="lazy">` : ''}</span>` +
                  `<span class="ppv-rv__txt"><span class="ppv-rv__vendor">${escapeHtml(offer.vendor)}</span><span class="ppv-rv__name">${escapeHtml(offer.title)}</span>` +
                  `<span class="ppv-rv__meta">2 ml · <b>${this.money(offer.price)}</b></span></span>` +
                  `<span class="ppv-rv__plus">${ICON_PLUS}${ICON_CHECK}</span></button>`
              )
              .join('');
          }
          clearTimeout(this.recentHideTimer);
          if (block.hidden) {
            block.hidden = false;
            void block.offsetHeight;
          }
          block.classList.remove('is-gone');
        });
      }

      showRecentError() {
        const box = this.querySelector('.ppv-rv__error');
        if (!box) return;
        box.textContent = RECENT_ERROR;
        clearTimeout(this.recentErrorTimer);
        this.recentErrorTimer = setTimeout(() => {
          box.textContent = '';
        }, 6000);
      }

      /* „+“ legt die 2-ml-Probe in den Warenkorb – wie der Warenkorb-Knopf von Dawn (product-form.js): Einschub und
         Zähler aus der Antwort neu zeichnen. Gemeldet wird mit der Quelle „cart-items“ (wie beim Größenwechsel): wir
         zeichnen selbst neu, sonst lädt Dawn den Einschub ein zweites Mal und wischt das Aufleuchten weg. */
      addRecent(card) {
        if (card.classList.contains('is-added') || card.getAttribute('aria-busy') === 'true') return;
        const drawer = this.closest('cart-drawer');
        if (!drawer) return;
        const variant = card.dataset.variant;
        const body = new FormData();
        body.append('id', variant);
        body.append('quantity', '1');
        if (typeof drawer.getSectionsToRender === 'function') {
          body.append('sections', drawer.getSectionsToRender().map(section => section.id));
          body.append('sections_url', window.location.pathname);
        }
        const config =
          typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/javascript' } };
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = body;
        const hasPubSub = typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
        const hadFocus = card === document.activeElement;
        const errorBox = this.querySelector('.ppv-rv__error');
        if (errorBox) errorBox.textContent = '';
        card.setAttribute('aria-busy', 'true');

        fetch((window.routes && window.routes.cart_add_url) || `${root()}cart/add`, config)
          .then(response => response.json())
          .then(response => {
            if (response.status) {
              if (hasPubSub) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'ppv-zuletzt',
                  productVariantId: variant,
                  errors: response.errors || response.description,
                  message: response.message
                });
              }
              this.showRecentError();
              return;
            }
            card.classList.add('is-added');
            card.setAttribute('aria-label', `${card.dataset.name}, 2 ml liegt im Warenkorb`);
            this.recentHoldUntil = Date.now() + 700;
            if (hasPubSub) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', productVariantId: variant, cartData: response });
            }
            /* Auf der Warenkorb-Seite steht der Warenkorb zusätzlich als Tabelle – die zieht nur ein Neuladen sicher mit. */
            if (document.querySelector('#main-cart-items') || typeof drawer.renderContents !== 'function' || !response.sections) {
              window.location.reload();
              return;
            }
            drawer.renderContents(response);
            /* Nach dem Neuzeichnen (der Block steckt dann wieder in der Liste): neue Zeile aufleuchten lassen
               (wie beim Größenwechsel, assets/ppv-cart-size.css) und den Fokus dorthin setzen. */
            requestAnimationFrame(() => {
              const input = drawer.querySelector(`.quantity__input[data-quantity-variant-id="${variant}"]`);
              const row = input && input.closest('.cart-item');
              if (row) {
                row.classList.remove('ppv-size-moved');
                void row.offsetWidth;
                row.classList.add('ppv-size-moved');
                row.addEventListener('animationend', () => row.classList.remove('ppv-size-moved'), { once: true });
              }
              if (hadFocus) {
                const target = (row && row.querySelector('.cart-item__name')) || drawer.querySelector('.drawer__inner');
                target?.focus({ preventScroll: true });
              }
            });
          })
          .catch(() => this.showRecentError())
          .finally(() => card.removeAttribute('aria-busy'));
      }

      refresh() {
        return readCart();
      }
    }

    customElements.define(ELEMENT_NAME, PPVCartRewards);
  }

  const firstElement = document.querySelector(ELEMENT_NAME);
  if (firstElement && !window.PPV_CART_REWARDS_TEMPLATE) {
    window.PPV_CART_REWARDS_TEMPLATE = firstElement.outerHTML;
  }

  if (window.__PPV_CART_REWARDS_CONTROLLER__) return;
  window.__PPV_CART_REWARDS_CONTROLLER__ = true;

  /* Checkout erst, wenn der Vermerk am Warenkorb steht: Warenkorb frisch lesen, Vermerk abgleichen (auch die
     Vorauswahl ab 30 €), dann weiter – höchstens 2,5 s warten, damit der Checkout nie hängen bleibt. */
  document.addEventListener(
    'submit',
    event => {
      const submitter = event.submitter;
      const form = event.target;
      if (!submitter || submitter.name !== 'checkout' || form.dataset.ppvSampleChecked === '1') return;
      event.preventDefault();
      let done = false;
      const proceed = () => {
        if (done) return;
        done = true;
        form.dataset.ppvSampleChecked = '1';
        if (form.requestSubmit) {
          form.requestSubmit(submitter);
        } else {
          const checkout = document.createElement('input');
          checkout.type = 'hidden';
          checkout.name = 'checkout';
          checkout.value = submitter.value || '';
          form.appendChild(checkout);
          form.submit();
        }
        delete form.dataset.ppvSampleChecked;
      };
      setTimeout(proceed, 2500);
      const postsBefore = state.postSeq;
      fetch(`${root()}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(response => (response.ok ? response.json() : null))
        .then(cart => {
          if (!cart) return state.queue;
          if (state.postSeq !== postsBefore && state.cart) cart.attributes = state.cart.attributes;
          applyCart(cart);
          return state.queue;
        })
        .catch(() => {})
        .finally(proceed);
    },
    true
  );

  /* Die Theme-Skripte ersetzen den Einschub bei jeder Änderung. Das lebende Element wird sofort (vor dem Zeichnen)
     wieder eingesetzt – mit Auswahl und Fortschritt, ohne Springen. */
  const places = { drawer: null, page: null };

  const fromTemplate = () => {
    if (!window.PPV_CART_REWARDS_TEMPLATE) return null;
    const holder = document.createElement('div');
    holder.innerHTML = window.PPV_CART_REWARDS_TEMPLATE;
    return holder.firstElementChild;
  };

  /* parent: als erstes Kind dort einsetzen (Einschub: Anfang der scrollenden Artikelliste). Ist dort gerade ein
     Mengenknopf o. Ä. fokussiert, bleibt er an seiner Stelle – der Block kommt oberhalb dazu, ohne dass die Liste springt. */
  const prependKeepingFocus = (parent, element) => {
    if (parent.firstElementChild === element) return;
    const focused = document.activeElement;
    const keep = focused && focused !== document.body && parent.contains(focused) && !element.contains(focused);
    const before = keep ? focused.getBoundingClientRect().top : 0;
    parent.prepend(element);
    if (keep) parent.scrollTop += focused.getBoundingClientRect().top - before;
  };

  const place = (key, container, anchor, parent) => {
    if (!container) return;
    const present = [...container.querySelectorAll(ELEMENT_NAME)];
    let element = places[key];
    if (element && !container.contains(element) && present[0]) {
      /* Frisch gerenderte Kopie markiert die richtige Stelle – dort das lebende Element einsetzen. */
      present[0].replaceWith(element);
    } else if (!element) {
      element = present[0] || fromTemplate();
    }
    if (!element) return;
    places[key] = element;
    container.querySelectorAll(ELEMENT_NAME).forEach(other => {
      if (other !== element) other.remove();
    });
    if (parent) {
      prependKeepingFocus(parent, element);
    } else if (anchor) {
      if (anchor.nextElementSibling !== element) anchor.insertAdjacentElement('afterend', element);
    } else if (!container.contains(element)) {
      container.prepend(element);
    }
  };

  const placeAll = () => {
    const drawer = document.querySelector('#CartDrawer') || document.querySelector('cart-drawer');
    if (drawer) {
      const inner = drawer.querySelector('.drawer__inner') || drawer;
      /* In der scrollenden Artikelliste statt fest unter der Kopfzeile – auf dem Handy scrollt der Block mit weg. */
      const scroller = inner.querySelector('cart-drawer-items');
      if (scroller) place('drawer', inner, null, scroller);
      else place('drawer', inner, inner.querySelector('.drawer__header'));
    }
    const isCartPage = /(^|\/)cart\/?$/.test(window.location.pathname) || document.body.classList.contains('template-cart');
    const cartSection = isCartPage ? document.querySelector('#main-cart-items') : null;
    if (cartSection) {
      /* Die Warenkorb-Seite rendert den Block selbst (unter „Weiter shoppen“) – nur Doppelte entfernen. */
      const wrapper = cartSection.closest('[id^="shopify-section-"]') || cartSection.parentElement;
      place('page', wrapper, wrapper.querySelector('.cart__warnings') || wrapper.querySelector('.title-wrapper-with-link'));
    } else {
      document.querySelectorAll(ELEMENT_NAME).forEach(element => {
        if (!element.closest('#CartDrawer,cart-drawer')) element.remove();
      });
    }
  };

  const WATCHED = '#CartDrawer, cart-drawer, #main-cart-items, cart-items';
  const isRelevantMutation = mutation => {
    const target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
    if (!target || target.closest(ELEMENT_NAME)) return false;
    if (target.closest(WATCHED)) return true;
    return [...mutation.addedNodes, ...mutation.removedNodes].some(
      node => node.nodeType === 1 && (node.matches?.(WATCHED) || node.querySelector?.(WATCHED))
    );
  };

  /* Gelesen wird nur, wenn Warenkorb-Inhalt neu gezeichnet wurde – nicht, wenn eine App etwas in den Einschub hängt. */
  const CART_CONTENT = '.cart-item, cart-drawer-items, .drawer__inner, .js-contents, .cart-items';
  const isCartRender = mutation =>
    [...mutation.addedNodes, ...mutation.removedNodes].some(
      node => node.nodeType === 1 && (node.matches?.(CART_CONTENT) || node.querySelector?.(CART_CONTENT))
    );

  new MutationObserver(mutations => {
    if (!mutations.some(isRelevantMutation)) return;
    placeAll();
    if (mutations.some(isCartRender)) requestRead(false);
  }).observe(document.body, { childList: true, subtree: true });

  /* Dawn meldet jede Änderung (pubsub). Bringt die Meldung den ganzen Warenkorb mit (Mengenänderung, Größenwechsel),
     genügt der – sonst einmal nachlesen. */
  const isFullCart = data =>
    Boolean(data) && Array.isArray(data.items) && typeof data.total_price === 'number' && typeof data.item_count === 'number' && Boolean(data.attributes) && typeof data.token === 'string';
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      const data = event && event.cartData;
      if (isFullCart(data)) applyCart(data, true);
      else requestRead(true);
    });
  }

  ['cart:updated', 'cart-updated', 'ajaxCart:updated', 'shopify:cart:updated'].forEach(eventName => {
    document.addEventListener(eventName, () => requestRead(true));
  });

  /* „Zuletzt angesehen“ lädt erst, wenn der Einschub aufgeht. */
  const drawerElement = document.querySelector('cart-drawer');
  if (drawerElement) {
    let wasOpen = drawerElement.classList.contains('active');
    new MutationObserver(() => {
      const open = drawerElement.classList.contains('active');
      if (open && !wasOpen) renderAll();
      /* Beim Schließen klappt die Auswahl der Gratisprobe wieder zu */
      if (!open && wasOpen) drawerElement.querySelectorAll(ELEMENT_NAME).forEach(element => element.setOpen?.(false));
      wasOpen = open;
    }).observe(drawerElement, { attributes: true, attributeFilter: ['class'] });
  }

  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    placeAll();
    requestRead(true);
  });
  placeAll();
})();
